"use client"

import { Header } from "@/components/dashboard/header"
import { SyncStatusWidget } from "@/components/dashboard/sync-status-widget"
import { LicenseUsageWidget } from "@/components/dashboard/license-usage-widget"
import { NoticesWidget } from "@/components/dashboard/notices-widget"
import { QuickActionsWidget } from "@/components/dashboard/quick-actions-widget"
import { useAuth } from "@/lib/auth-context"

export default function DashboardPage() {
  const { user } = useAuth()

  const displayName = user?.name?.replace(/\s+/g, "")?.slice(0, -1) ?? "ユーザー"
  const lastLogin = user?.last_login_at
    ? new Date(user.last_login_at).toLocaleString("ja-JP", {
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit",
      })
    : "---"
  const lastIp = user?.last_login_ip ?? "---"

  return (
    <>
      <Header />

      <main className="p-6">
        {/* Welcome Banner */}
        <div className="mb-6 rounded-lg bg-gradient-to-r from-primary/10 to-accent/30 p-6">
          <h2 className="text-xl font-semibold text-foreground">
            おかえりなさい、{displayName}様
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">
            本日も Bugyo Archive Cloud をご利用いただきありがとうございます。
          </p>
        </div>

        {/* Dashboard Widgets Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          <SyncStatusWidget />
          <LicenseUsageWidget />
          <QuickActionsWidget />

          <div className="md:col-span-2 lg:col-span-3">
            <NoticesWidget />
          </div>
        </div>

        {/* Footer Info */}
        <div className="mt-8 flex items-center justify-between border-t border-border pt-6 text-xs text-muted-foreground">
          <p>
            最終ログイン: {lastLogin} | IP: {lastIp}
          </p>
          <p>
            Bugyo Archive Cloud v2.1.0
          </p>
        </div>
      </main>
    </>
  )
}
